/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "../components/SmoothScroll";
const Disclaimer = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
<div>
    <title>
        Disclaimer | Citrus Diagnostic Center Crystal River,Florida
      </title>
      <meta
        name="description"
        content="This service disclaimer explains that all medical imaging information provided by Citrus Diagnostic Center is for general guidance and not a substitute for care."
      />
     <div className="flex justify-center items-center pt-48 lg:pt-[14.0625rem]">
      <div className="w-4/5  flex flex-col items-center  pb-8 lg:pb-16">
        <h1
         
          className="text-[#d78558] font-robout lg:text-6xl md:text-5xl text-4xl lg:pb-20 capitalize  leading-tight sm:leading-snug font-black"
        >
         Disclaimer
        </h1>
        <div className="md:text-left text-center">
          <p className="lg:text-2xl md:text-lg text-lg text-white lg:ps-0 md:px-8  py-16  font-robout">
            All information provided on this site is for general information
            purposes and is not intended or implied to be used to make decisions
            on medical treatment or to make a diagnosis of a medical problem. No
            information provided is intended or implied to replace consultation
            with a qualified physician. Medical information on this site is
            provided by Citrus Diagnostic Center, (“CDC”) a Florida professional
            company providing radiology services. Citrus Diagnostic Center does
            not practice medicine, nor does it provide medical advice. You
            should discuss medical questions with your physician or other
            qualified healthcare provider before deciding on any diagnostic
            tests. All information from this or any other source needs to be
            reviewed carefully with your own doctor before you act upon it in
            any way. While this site attempts to provide information which may
            be relevant to you, no guarantees are made that some relevant
            information will not be missed.
          </p>
          <h2 className="lg:text-3xl text-2xl  text-[#d78558] font-bold lg:ps-0 md:px-8  py-10">
            If you suspect you have a health problem, you should seek immediate
            care with a qualified health care professional
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8  pb-16   font-robout">
            With respect to any documents and information made available from
            this site, Citrus Diagnostic Center, its employees, CDC physicians
            and other parties involved in the creation, production or delivery
            of this site are not liable for any direct, incidental,
            consequential, indirect, or punitive damages arising out of your
            access to, or use of, this site. Neither Citrus Diagnostic Center
            nor any of its employees, associates or CDC physicians makes any
            warranty, express or implied, about this site, including but not
            limited to the implied warranties of merchantability, fitness for a
            particular purpose and non-infringement. Likewise, neither Citrus
            Diagnostic Center nor any CDC physician assumes any legal liability
            or responsibility for the accuracy, completeness, or usefulness of
            any information, procedure, method, apparatus, product, or process
            posted on the site. Neither Citrus Diagnostic nor its employees,
            associates or CDC physicians assume any responsibility for loss or
            damages resulting from the use of information contained on this
            site.
          </p>
          <h2 className="lg:text-3xl text-2xl  text-[#d78558] font-bold  lg:ps-0 md:px-8  py-10">
            Links
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8  pb-8   font-robout">
            Citrus Diagnostic Center’s Web site may contain links to other Web
            sites. Citrus Diagnostic Center is not responsible for the privacy
            practices of these other sites. Users are encouraged to read the
            privacy statements of every Web site that collects any personal
            information. This privacy statement applies solely to information
            collected on the Citrus Diagnostic Center Web site.
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8  pb-8 font-robout">
            Citrus Diagnostic Center does not warrant or guarantee that any
            files, links, or pointers available through this site will be free
            of viruses or other codes that contain contaminating or destructive
            properties. In consideration for receiving this information on the
            Citrus Diagnostic Center site, you agree to release and covenant not
            to sue Citrus Diagnostic Center, its employees, associates and CDC
            physicians from and against any and all claims. You agree to hold
            Citrus Diagnostic Center, its employees and associates harmless
            should your system become damaged in any way from using this web
            site. You agree that your sole and exclusive remedy for loss or
            dissatisfaction associated with using this site is to stop using the
            site.F
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8  pb-8  font-robout">
            Please note that all contents of this message, including any advice,
            suggestions, and/or recommendations has NOT been generated as part
            of any professional evaluation. No patient has been examined prior
            to making these comments; no professional fee has been charged by or
            paid to CDC or Citrus Diagnostic Center. Citrus Diagnostic Center
            does not practice medicine. You are advised to discuss any comments
            given with a physician or other qualified healthcare provider, and
            to only act upon the advice of a physician or other qualified
            healthcare provider. The posting of any answer to your questions
            does NOT create a physician-patient relationship between you and
            CDC. Although identities may remain confidential, Citrus Diagnostic
            Center, its employees and associates take no responsibility for any
            breaches of confidentiality that may occur.
          </p>

          <h2 className="lg:text-3xl text-2xl font-bold   text-[#d78558] capitalize lg:ps-0 md:px-8 py-10">
            Proprietary Rights
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 pb-16  font-robout">
            Images of people or places displayed on the site are the property of
            either Citrus Diagnostic Center or a third party. The use of these
            images by you or anyone authorized by you, is prohibited unless you
            obtain the express, written permission of Citrus Diagnostic Center.
            Any unauthorized use of these images may violate copyright laws,
            trademark laws, the laws of privacy and publicity, and
            communications regulations and statutes.
          </p>
        </div>
      </div>
    </div>
</div>
  );
};

export default Disclaimer;
